import { useCallback, useEffect, useState } from "react";

// The session lasts as long as the loginAt cookie in api/service.js.
const SESSION_MINUTES = 480;

// Prompt for re-authentication this many minutes before the session ends.
const RENEWAL_WARNING_MINUTES = 30;

const CHECK_INTERVAL_MS = 15000;

function getLoginAt(cookie = document.cookie) {
  const match = cookie.match(/(?:^|;\s*)loginAt=(\d+)/);
  return match ? Number(match[1]) : null;
}

function isRenewalDue(
  loginAt,
  now,
  warningMinutes = RENEWAL_WARNING_MINUTES,
  sessionMinutes = SESSION_MINUTES
) {
  // no login time means an older session, so leave the user alone
  if (!loginAt) {
    return false;
  }

  const expiresAt = loginAt + sessionMinutes * 60 * 1000;

  return expiresAt - now <= warningMinutes * 60 * 1000;
}

function useRenewalDue() {
  const [renewalDue, setRenewalDue] = useState(false);

  const check = useCallback(() => {
    setRenewalDue(isRenewalDue(getLoginAt(), Date.now()));
  }, []);

  useEffect(() => {
    check();

    // re-check on focus so renewing in another tab clears the prompt
    const interval = setInterval(check, CHECK_INTERVAL_MS);
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [check]);

  return renewalDue;
}

export {
  RENEWAL_WARNING_MINUTES,
  SESSION_MINUTES,
  getLoginAt,
  isRenewalDue,
  useRenewalDue,
};
